import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeProcessingStatusComponent } from './employee-processing-status.component';

const routes: Routes = [
  {
    path: '',
    component: EmployeeProcessingStatusComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeProcessingStatusRoutingModule {}
